import { render, staticRenderFns } from "./ModalDetalhes.vue?vue&type=template&id=8bbad0f4&scoped=true"
import script from "./ModalDetalhes.vue?vue&type=script&lang=js"
export * from "./ModalDetalhes.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalhes.vue?vue&type=style&index=0&id=8bbad0f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbad0f4",
  null
  
)

export default component.exports